import { render } from "./TopPerformingCompaign.vue?vue&type=template&id=8a211f28&scoped=true"
import script from "./TopPerformingCompaign.vue?vue&type=script&lang=js"
export * from "./TopPerformingCompaign.vue?vue&type=script&lang=js"

import "./TopPerformingCompaign.vue?vue&type=style&index=0&id=8a211f28&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a211f28"]])

export default __exports__